var React = require('react');

function Share (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"5","r":"3","key":0}),React.createElement("circle",{"cx":"6","cy":"12","r":"3","key":1}),React.createElement("circle",{"cx":"18","cy":"19","r":"3","key":2}),React.createElement("line",{"x1":"8.59","y1":"13.51","x2":"15.42","y2":"17.49","key":3}),React.createElement("line",{"x1":"15.41","y1":"6.51","x2":"8.59","y2":"10.49","key":4})]);
}

Share.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-share-2"};

module.exports = Share;

Share.default = Share;
